<template>
    <div >
        <div class="grid grid-cols-2 gap-2 ">
            <div v-for="item in pager.items" :key="item.id" class="grid gap-2 list" @click="toDetail(item.id)">
                <img :src="$firstImage(item.viewimage, 'normal')" class="img ">
                <span class="title">{{ item.title }}</span>
                <div class="hide">
                    {{ delHtmlTag(item.content) }}
                </div>
            </div>
            <div style="width: 100vw;">
                <div style="width: 80vw;margin:auto">
                    <img>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            pager:this.$Pager({
				apiname:'news/getNewsList',
                size:-1,
				param:{
					tag:'cusprocess'
				}
			})
        }
    },
    async mounted(){
        this.loadData()
    },
    methods:{
        async loadData(){
            await this.pager.first()
        },
        //去除html 标签
        delHtmlTag(str) {
            return str.replace(/<[^>]+>/g, "");
        },
        toDetail(id){
            this.$router.push({path:'/newsDetail',query:{id:id,title:this.$t('外贸服务'),name:'cusprocess'}})
        }
    }
}
</script>
<style scoped lang="scss">
.banner{
    max-width: 100%; height: auto; object-fit: contain;
}

.hide {
  width: 100%;
  height: 6rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.list{
    background-color: #ffffff;
    padding: 1.5rem;
    grid-template-columns: 10.25rem auto;
    justify-items: flex-start;
    cursor: pointer;
    .img{
        width: 10.25rem;
        height: 7.44rem;
        grid-row: 1/3;
    }
    .title{
        font-weight: bold;
        font-size: 1.125rem;
    }
}
</style>